import { Standard } from "./Standard";
import { SingleLine } from "./SingleLine";
import { LogoOnly } from "./LogoOnly";
import { Inversed } from "./Inversed";
import { SingleLineInversed } from './SingleLineInversed';
import { CustomImage, CustomCopy, CustomLink } from "./Custom";
import { CustomPoints } from "./CustomPoints";


export const LAYOUT_TYPE = {
  STANDARD: "standard",
  SINGLE_LINE: "single-line",
  SINGLE_LINE_INVERSED: "single-line-inversed",
  FULLWIDTH: "fullwidth",
  INLINE: "inline",
  LOGO_ONLY: "logo-only",
  INVERSED: "inversed",
  CUSTOM_IMAGE: "custom-image",
  CUSTOM_COPY: "custom-copy",
  CUSTOM_LINK: "custom-link",
  CUSTOM_POINTS: 'custom-points'
};

export const ALLOWED_LAYOUTS = [
  LAYOUT_TYPE.STANDARD,
  LAYOUT_TYPE.SINGLE_LINE,
  LAYOUT_TYPE.SINGLE_LINE_INVERSED,
  LAYOUT_TYPE.FULLWIDTH,
  LAYOUT_TYPE.INLINE,
  LAYOUT_TYPE.LOGO_ONLY,
  LAYOUT_TYPE.INVERSED,
  LAYOUT_TYPE.CUSTOM_IMAGE,
  LAYOUT_TYPE.CUSTOM_LINK,
  LAYOUT_TYPE.CUSTOM_COPY,
  LAYOUT_TYPE.CUSTOM_POINTS
];

export const Banner = props => {
  let resp;

  switch (props?.layout) {
    case LAYOUT_TYPE.STANDARD:
    case LAYOUT_TYPE.FULLWIDTH:
      resp = Standard(props);
      break;
    case LAYOUT_TYPE.SINGLE_LINE:
      resp = SingleLine(props);
      break;
    case LAYOUT_TYPE.SINGLE_LINE_INVERSED:
      resp = SingleLineInversed(props);
      break;
    case LAYOUT_TYPE.LOGO_ONLY:
    case LAYOUT_TYPE.INLINE:
      resp = LogoOnly(props);
      break;

    case LAYOUT_TYPE.INVERSED:
      resp = Inversed(props);
      break;

    case LAYOUT_TYPE.CUSTOM_IMAGE:
      resp = CustomImage(props);
      break;

    case LAYOUT_TYPE.CUSTOM_COPY:
      resp = CustomCopy(props);
      break;

    case LAYOUT_TYPE.CUSTOM_LINK:
      resp = CustomLink(props);
      break;

    case LAYOUT_TYPE.CUSTOM_POINTS:
      resp = CustomPoints(props);
      break;

    default:
      resp = "";
      break;
  }

  return resp;
};